import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, IRowNode } from '@ag-grid-community/core';
import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ActivityType } from 'aws-sdk/clients/swf';

import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { MapActivitiesGridRow, MapActivityType } from '../map-activities-modal.model';

export type AgBudgetActivityDropdownParams = ICellRendererParams & {
  options: ActivityDropdownOption[];
  updateTotals: () => void;
  validateCell: (isInvalidValue: boolean, data: MapActivitiesGridRow, node: IRowNode) => void;
};

type ActivityDropdownOption = {
  activity_type: ActivityType;
  categories: {
    index: number;
    level: string;
    name: string;
  }[];
  categoryTitles?: { level: number; name: MapActivityType | string }[];
  label: string;
  path: string;
  value: string;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectModule, FormsModule, ReactiveFormsModule, TooltipDirective, NgClass, NgStyle],
  selector: 'aux-ag-budget-activity-dropdown',
  styleUrl: 'ag-budget-activity-dropdown.component.scss',
  templateUrl: 'ag-budget-activity-dropdown.component.html',
})
export class AgBudgetActivityDropdownComponent implements ICellRendererAngularComp {
  formControl = new FormControl();
  params!: AgBudgetActivityDropdownParams;
  @ViewChild('select', { static: true }) select!: NgSelectComponent;

  agInit(params: AgBudgetActivityDropdownParams): void {
    this.params = params;
    this.formControl.setValue(params.data.activity_id || null);
  }

  getCategoryTitles(path: string): { level: number; name: MapActivityType | string }[] {
    return this.params.options.find((option) => option.path === path)?.categoryTitles || [];
  }

  getValue(): null | string {
    return this.formControl.value;
  }

  onChange(): void {
    const newValue = this.params.options.find(({ value }) => value === this.formControl.value);

    this.params.node.updateData({
      ...this.params.node.data,
      activity_id: this.formControl.value,
      activity_name: newValue ? newValue.label : null,
      activity_type: newValue ? newValue.activity_type : null,
    });

    this.params.validateCell(
      !this.formControl.value || !this.params.data.amount,
      this.params.node.data,
      this.params.node
    );

    this.params.updateTotals();
  }

  refresh(): boolean {
    return false;
  }
}
